import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad } from '../components/';
import { Dictionary } from '../Dati';
import { InputLimite } from '../components/';


interface IInputNumeroConSegnoProps extends Dati.IBaseProps {
    Etichetta: string;
    Valore: number;
    Minimo?: number;
    Massimo?: number;
    Precisione?: number;
    Disabilitato?: boolean;
}

export class InputNumeroConSegno extends BasePureComponent<IInputNumeroConSegnoProps, {}> {
    private _Valore: number = 0;
    constructor(props: any) {
        super(props);
        this._Valore = this.props.Valore;
    }

    private OnAggiorna(e: React.FormEvent<any>): void {
        this._Valore = e.currentTarget.value;
        this.props.OnChange(this.props.Name, this._Valore);
    }

    public render() {
        this._Valore = this.props.Valore;
        return <InputLimite
            Valore={this._Valore}
            Name={this.props.Name}
            Id={this.props.Id}
            OnChange={(e) => this.OnAggiorna((e as React.FormEvent<any>))}
            OnBlur={this.props.OnBlur}
            Scrittura={this.props.Scrittura}
            Minimo={this.props.Minimo}
            Massimo={this.props.Massimo}
            AbilitaIncremento={this.props.Disabilitato != undefined ? !this.props.Disabilitato : true}
            AbilitaDecremento={this.props.Disabilitato != undefined ? !this.props.Disabilitato : true}
            Disabilitato={this.props.Disabilitato}
            Label={this.props.Etichetta}
            CSS={this.props.CSS}
            Precisione={this.props.Precisione} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/InputNumeroConSegno.tsx